import React from 'react'
import ClockIconSvg from "../ClockIconSvg"
import CoachIcon from "../CoachIconSvg"
import classes from '../../FitnessPreview.module.scss'

const DurationAndCoach = ({ coachName, programDuration, coachImageUrl = "" }) => {
    return <div className={classes.durationAndCoach}>
        <span className='d-flex align-items-center gap-1'>
            <ClockIconSvg />
            <div className='font-size-12 font-weight-normal'>{programDuration} weeks</div>
        </span>

        <span className='d-flex align-items-center gap-1'>
            {coachImageUrl === '' ? <CoachIcon /> : <img src={coachImageUrl} />}
            <div className='font-size-12 font-weight-normal'>{coachName}</div>
        </span>

    </div>
}

export default DurationAndCoach